<template>
  <div class="flex h-[55%] w-full flex-col items-center justify-center">
    <div
      class="flex h-[20%] w-full items-center px-4 text-[4vw] md:text-[1.25vw] font-bold text-white"
      :class="{ 'justify-end': locale === 'ar' }"
    >
      {{ title }}
    </div>
    <div
      class="my-4 flex h-[80%] w-[90%] justify-center rounded-2xl bg-zinc-700/50 py-4"
    >
      <div
        class="flex h-full w-full flex-wrap items-center justify-center gap-4 overflow-y-auto rounded-lg"
      >
        <div
          v-for="stadium in stadiums"
          :key="stadium.name"
          @click="!isTransitioning ? selectedStadium(stadium.id) : null"
          class="relative box-border flex md:min-h-[4.5rem] h-[9vh] w-[44%] cursor-pointer items-center justify-center rounded-lg border-2 transition-colors hover:border-slate-300"
          :class="
            modelValue === stadium.id
              ? 'border-saudi-purple'
              : 'border-zinc-700'
          "
        >
          <img
            class="h-full w-full rounded-md object-fill"
            :src="stadium.exImage"
          />
          <div
            :class="
              locale === 'ar'
                ? 'text-right justify-end'
                : 'text-left justify-start'
            "
            class="absolute bottom-0 flex h-[40%] items-center w-full rounded-b-md bg-zinc-700 text-[1.8vw] text-white bg-opacity-75 md:h-[40%] md:text-[0.65vw]"
          >
            <p class="ml-[1%] font-bold">
              {{ locale === "en" ? stadium.enName : stadium.arName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

defineProps({
  modelValue: Number,
  stadiums: Array,
  title: String,
  isTransitioning: Boolean,
  locale: String,
});

const { locale } = useI18n();

const emit = defineEmits(["update:modelValue"]);
let currentStadiumID = 0;

const selectedStadium = (stadiumId) => {
  if (stadiumId === currentStadiumID) {
    stadiumId = null;
  }

  emit("update:modelValue", stadiumId);

  if (stadiumId) {
    currentStadiumID = stadiumId;

    if (typeof window.gtag === "function") {
      window.gtag("event", "stadium_click", {
        stadium_id: stadiumId,
        value: 1,
      });
    }
  } else {
    currentStadiumID = stadiumId;
  }
};
</script>
